/**
 * /tenants/$slug/agents/edge — the edge console (AI agents → Agent governance).
 *
 * Thin shim: validate search, prefetch the roster, mount the feature page.
 *
 * The loader's prefetch deliberately swallows a rejection, and it still should now that the reads
 * are behind edge.read rather than a step-up permission: an operator whose roster read fails —
 * a 403 from a role that lost the permission, a 503 from the plane — belongs on the page with the
 * banner and its retry button, not on the router's error screen with no way back.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchEdgeDeployments } from "@/features/edge-deployments/queries";
import { edgeDeploymentsSearchSchema, type EdgeDeploymentsSearch } from "@/features/edge-deployments/schemas";
import { EdgeDeploymentsPage } from "@/features/edge-deployments/pages/edge-deployments-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/edge")({
  validateSearch: (raw: Record<string, unknown>): EdgeDeploymentsSearch =>
    edgeDeploymentsSearchSchema.parse(raw),
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData({
        queryKey: queryKeys.edgeDeployments.list(context.tenant.id),
        queryFn: () => fetchEdgeDeployments(context.tenant.id),
      })
      .catch(() => undefined),
  component: EdgeDeploymentsPage,
});
